module.exports = __webpack_public_path__ + "img/logo_Smoke_Dispersion.5bc86ac5.png";